import React, { useEffect } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';
import { Typography } from '@material-ui/core';
import * as _ from 'lodash';
import { Grid, TextField, Box, Select, MenuItem, InputLabel, Button } from '@material-ui/core';
import { DialogForm } from '../../components/DialogForm';
import { Trash, Edit } from '@jda/lui-common-icon-library';
import { WORKFLOW_LIST, ADD_TEST_RULE } from '../graphQL/queries';
import useStyles from './Style';
import AddRuleDialog from './AddRuleDialog';

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};

type workflowContentData = {
  content: workflowInfo[];
};

const AddTestRules = (props: any) => {
  const classes = useStyles();
  const { simulatedService } = props;
  const [addTestRule] = useMutation(ADD_TEST_RULE);
  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const [test_workflowName, setWorkflowName] = React.useState('');
  const [test_operation, setOperation] = React.useState('');
  const [scenarioOperations, setScenarioOperations] = React.useState<any>([]);
  const [testDataNames, setTestDataNames] = React.useState<any>([]);
  const { enqueueSnackbar } = useSnackbar();
  const [formInfo, setFormInfo] = React.useState<any>({});
  const [edit, isEdit] = React.useState(false);
  const [ruleData, setRuleData] = React.useState<any>({});

  useEffect(() => {
    if (props.edit) {
      if (simulatedService?.simulatedData?.content?.length > 0) {
        const services = simulatedService?.simulatedData?.content;
        let operations: any = [];
        let testDataNamesList: any = [];
        for (let i = 0; i < services?.length; i++) {
          if (props.formData.serviceNm === services[i].serviceNm) {
            const obj = {
              label: services[i].operation,
              value: services[i].operation,
              serviceNm: services[i].serviceNm,
              testDataName: services[i].testDataName
            };
            const testObj = {
              label: services[i].testDataName,
              value: services[i].testDataName,
              serviceNm: services[i].serviceNm,
              testDataName: services[i].testDataName
            };
            testDataNamesList.push(testObj);
            operations.push(obj);
          }
        }
        setTestDataNames(testDataNamesList);
      }
    } else {
      if (simulatedService?.simulatedData?.content?.length > 0) {
        const services = simulatedService?.simulatedData?.content;
        let operations: any = [];
        let testDataNamesList: any = [];
        for (let i = 0; i < services?.length; i++) {
          const obj = {
            label: services[i].operation,
            value: services[i].operation,
            serviceNm: services[i].serviceNm,
            testDataName: services[i].testDataName
          };
          const testObj = {
            label: services[i].testDataName,
            value: services[i].testDataName,
            serviceNm: services[i].serviceNm,
            testDataName: services[i].testDataName
          };
          testDataNamesList.push(testObj);
          operations.push(obj);
        }
        setTestDataNames(testDataNamesList);
      }
    }
  }, [simulatedService, props.formData, props.edit]);

  useEffect(() => {
    if (props.edit) {
      const workflow =
        props.workflowList.data?.workflow?.content?.filter(
          (item: any) => item.workflowName === props.formData?.serviceNm
        ) || [];
      const operationsList = workflow[0]?.operations;
      setScenarioOperations(operationsList);
      setWorkflowName(props.formData.serviceNm);
      setOperation(props.formData.operation);

      const list: any = [];
      if (props.formData) {
        const additionalCredsObj = props.formData.testStepRulesSequences;
        _.keys(additionalCredsObj || []).forEach(keyParameter => {
          let step = 0;
          let comRule = '';
          const additionalParameterObj = additionalCredsObj[keyParameter];
          let ruleList: any = [];
          _.keys(additionalParameterObj['ruleOperators'] || []).forEach(ruleKey => {
            const obj = {
              operator: additionalParameterObj['ruleOperators']?.[ruleKey]?.operator,
              path: additionalParameterObj['ruleOperators']?.[ruleKey]?.path,
              value: additionalParameterObj['ruleOperators']?.[ruleKey]?.value,
              concatOperator: additionalParameterObj['ruleOperators']?.[ruleKey]?.concatOperator || '',
              step: step + 1,
              ruleFull:
                additionalParameterObj['ruleOperators']?.[ruleKey]?.path +
                additionalParameterObj['ruleOperators']?.[ruleKey]?.operator +
                additionalParameterObj['ruleOperators']?.[ruleKey]?.value
            };
            step = step + 1;
            comRule +=
              additionalParameterObj['ruleOperators']?.[ruleKey]?.concatOperator +
              additionalParameterObj['ruleOperators']?.[ruleKey]?.path +
              additionalParameterObj['ruleOperators']?.[ruleKey]?.operator +
              additionalParameterObj['ruleOperators']?.[ruleKey]?.value;
            ruleList.push(obj);
          });
          list.push({
            testRuleName: additionalParameterObj['testRuleName'],
            testDataName: additionalParameterObj['testDataName'],
            testComRuleName: comRule,
            ruleOperators: ruleList,
            [additionalParameterObj['sequence']]: ruleList,
            sequence: additionalParameterObj['sequence']
          });
        });
      }

      setFormInfo({
        parameters: [...list]
      });
    } else {
      setFormInfo({ ...props.formInfo });
    }
  }, [props.formData, props.edit, props.formInfo, props.ruleData]);

  const handleTestRulesSubmit = () => {
    const ruleList: any = [];
    if (formInfo.parameters) {
      _.forEach(formInfo.parameters || [], (element: any) => {
        const obj = {
          operation: test_operation,
          testDataName: element.testDataName,
          serviceNm: test_workflowName,
          sequence: element.sequence,
          testRuleName: element.testRuleName,
          ruleOperators: element?.[element.sequence]
        };
        ruleList.push(obj);
      });
    }
    props.handleDialogSubmit();
    addTestRule({
      variables: {
        operation: test_operation,
        serviceNm: test_workflowName,
        testStepRulesSequences: ruleList,
        method: props.edit ? 'PUT' : 'POST'
      }
    })
      .then(response1 => {
        enqueueSnackbar(props.edit ? 'Test rule details modified successfully !!' : 'Test rule added successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        props.refresh();
        return response1;
      })
      .catch(() => {
        enqueueSnackbar('Add Test Rule action failed !!', { variant: 'error', preventDuplicate: true });
      });
    setWorkflowName('');
    setOperation('');
    setFormInfo({});
  };

  const handleAddParameter = () => {
    const list = formInfo.parameters || [];
    list.push({
      testRuleName: '',
      testDataName: '',
      sequence: formInfo.parameters?.length ? formInfo.parameters?.length + 1 : 1,
      [formInfo.parameters?.length ? formInfo.parameters?.length + 1 : 1]: []
    });
    setFormInfo({
      ...formInfo,
      parameters: list
    });
  };

  const handleParameterChange = (e: any, index: number, label: string, key: any) => {
    if (label === 'rule') {
      _.forEach(formInfo.parameters || [], (element: any) => {
        let str = '';
        _.forEach(element?.[element?.sequence] || [], (item: any) => {
          str += item?.concatOperator + item?.path + item?.operator + item?.value;
        });
      });
    }

    if (label === 'testRuleName' || label === 'testDataName') {
      formInfo.parameters[index][label] = e.target.value;
    }

    if (
      label === 'operator' ||
      label === 'path' ||
      label === 'value' ||
      label === 'concatOperator' ||
      label === 'ruleFull'
    ) {
      formInfo.parameters?.map((item: any) => {
        (item?.[key] || [])?.map((op: any, ind: number) => {
          if (op.step === index) {
            if (label === 'ruleFull') {
              op[label] = op?.path + op?.operator + op?.value;
              console.log('ruleFull: ' + op?.path + op?.operator + op?.value);
            } else op[label] = e.target.value;
          }
        });
      });
    }

    setFormInfo({
      ...formInfo
    });
  };

  const handleFormFields = ({ target: { name, value } }: any) => {
    if (name === 'workflowCode') {
      setWorkflowName(value);
      const workflow =
        props?.workflowList?.data?.workflow?.content?.filter((item: any) => item.workflowName === value) || [];
      const operationsList = workflow[0].operations;
      if (simulatedService?.simulatedData?.content?.length > 0) {
        const services = simulatedService?.simulatedData?.content;
        let operations: any = [];
        let testDataNamesList: any = [];
        for (let i = 0; i < services?.length; i++) {
          if (services[i].serviceNm === value) {
            const obj = {
              label: services[i].operation,
              value: services[i].operation,
              serviceNm: services[i].serviceNm,
              testDataName: services[i].testDataName
            };
            const testObj = {
              label: services[i].testDataName,
              value: services[i].testDataName,
              serviceNm: services[i].serviceNm,
              testDataName: services[i].testDataName
            };
            testDataNamesList.push(testObj);
            operations.push(obj);
          }
        }
        setTestDataNames(testDataNamesList);
      }
      setScenarioOperations(operationsList);
    }
    if (name === 'operationName') {
      setOperation(value);
    }
  };

  const handleTestRulesClose = () => {
    props.handleDialogClose();
    setWorkflowName('');
    setOperation('');
    setFormInfo({});
  };

  const deleteList = (id: any) => {
    const list = formInfo.parameters?.filter((item: any) => item.sequence !== id);
    setFormInfo({
      parameters: [...list]
    });
  };

  const handleEditTestRules = (rowData: any) => {
    isEdit(true);
    setRuleData(rowData);
  };

  const handleRuleEditClose = () => {
    isEdit(false);
    setFormInfo({
      ...formInfo
    });
  };

  const handleRuleEditSubmit = (sequence: any) => {
    formInfo.parameters?.map((item: any) => {
      let comRule = '';
      (item?.[sequence] || [])?.map((element: any) => {
        comRule += element?.concatOperator + element?.path + element?.operator + element?.value;
      });
      if (item?.sequence === sequence) {
        item.testComRuleName = comRule;
      }
    });
    isEdit(false);
  };

  return (
    <>
      <AddRuleDialog
        handleDialogClose={handleRuleEditClose}
        handleDialogSubmit={handleRuleEditSubmit}
        edit={edit}
        formInfo={formInfo}
        setFormInfo={setFormInfo}
        sequenceNumber={ruleData?.sequence}
      />
      <DialogForm
        key={props.edit ? 'Edit-Test-Rules' : 'Add-Test-Rules'}
        openFn={props.dialogOpen}
        dataConfig={[]}
        handleDialogClose={handleTestRulesClose}
        handleDialogSubmit={handleTestRulesSubmit}
        submitlabel={'Save'}
        title={props.edit ? 'Edit Test Rules' : 'Add Test Rules'}
        dialogId="save-field-id"
        closeFn={handleTestRulesClose}
        maxWidth="lg"
        data={props?.formData}
      >
        <div id={props.title} key={props.title} className={classes.wrapper}>
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <Grid container id="maingrid" className={classes.mainGrid}>
                <Grid item xs={4} className={classes.gridSelection}>
                  <InputLabel id="WorkflowCode-label">Service Name</InputLabel>
                  <Select
                    id="Select-WorkflowCode"
                    data-id="Select-WorkflowCode"
                    name="workflowCode"
                    onChange={handleFormFields}
                    value={test_workflowName}
                    className={classes.select}
                    disabled={props.edit}
                  >
                    {props?.workflowList?.data?.workflow?.content?.map((service: any) => (
                      <MenuItem value={service.workflowName}>{service.workflowName}</MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={4}>
                  <InputLabel id="operationCode-label">Operation Name</InputLabel>
                  <Select
                    id="Select-operationCode"
                    data-id="Select-operationCode"
                    name="operationName"
                    onChange={handleFormFields}
                    value={test_operation}
                    className={classes.select}
                    disabled={props.edit}
                  >
                    {scenarioOperations?.map((operation: any) => (
                      <MenuItem value={operation.operationName}>{operation.operationName}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div id={props.title} key={props.title} className={classes.wrapper}>
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <Grid container id="maingrid" className={classes.mainGrid} justify="space-between">
                <Box className={classes.grid}>
                  <Grid container alignItems="center">
                    <Grid item xs={10}>
                      <Typography variant="h6" style={{ padding: '8px' }}>
                        List of Rules
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        data-id="add-Button"
                        className={classes.buttonMargin}
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={handleAddParameter}
                      >
                        Add Rule
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                <Box m={2} style={{ width: '100%' }}>
                  {(formInfo?.parameters || []).map((paramObj: any, index: number) => (
                    <div id={props.title} key={props.title} className={classes.wrapper}>
                      <Grid data-id={'checking'} container className={classes.container}>
                        <Grid item xs={12}>
                          <Grid container id="maingrid" className={classes.mainGrid} justify="space-between">
                            <Grid container style={{ width: '100%' }} spacing={3}>
                              <Grid item xs={1}>
                                <p>{index + 1}</p>
                              </Grid>
                              <Grid item xs={2} justify="center" alignItems="flex-end" style={{ width: '100%' }}>
                                <Typography className={classes.headers}>Rule Name</Typography>
                                <TextField
                                  data-id="ruleName-input"
                                  id="ruleName"
                                  name="ruleName"
                                  value={paramObj?.testRuleName || ''}
                                  onChange={e => handleParameterChange(e, index, 'testRuleName', 1)}
                                ></TextField>
                              </Grid>
                              <Grid item xs={3} justify="space-between" style={{ width: '100%' }}>
                                <Typography className={classes.headers}>Test Data Name</Typography>
                                <Select
                                  id="Select-testData"
                                  data-id="Select-testData"
                                  name="testDataName"
                                  onChange={e => handleParameterChange(e, index, 'testDataName', 2)}
                                  value={paramObj?.testDataName || ''}
                                  className={classes.select}
                                >
                                  {testDataNames?.map((testData: any) => (
                                    <MenuItem value={testData.testDataName}>{testData.testDataName}</MenuItem>
                                  ))}
                                </Select>
                              </Grid>
                              <Grid item xs={5} justify="center" alignItems="flex-end" style={{ width: '100%' }}>
                                <Typography className={classes.headers}>Rule</Typography>
                                <TextField
                                  data-id="rule-input"
                                  id="rule"
                                  name="rule"
                                  autoFocus={true}
                                  fullWidth={true}
                                  multiline={true}
                                  value={paramObj?.testComRuleName || ''}
                                  onChange={e => handleParameterChange(e, index, 'rule', paramObj?.sequence)}
                                  // style={{ width: '80%' }}
                                  //   required
                                  disabled
                                ></TextField>
                              </Grid>

                              <Grid item xs={1} style={{ width: '100%' }}>
                                <Edit
                                  data-id="edit-step"
                                  onClick={() => handleEditTestRules(paramObj)}
                                  style={{ cursor: 'pointer' }}
                                />
                                <Trash
                                  data-id="delete-step"
                                  onClick={() => deleteList(paramObj.sequence)}
                                  style={{ cursor: 'pointer' }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {/* )}  */}
      </DialogForm>
    </>
  );
};
export default AddTestRules;
